const navbar = document.getElementById('navbarSticky');
const header = document.getElementById('headerBeforeSticky');

if (navbar && header) {
  const sticky = navbar.offsetTop;

  function addSticky(element, before) {
    element.classList.add('sticky');
    before.classList.add('before-sticky');
  }

  function removeSticky(element, before) {
    element.classList.remove('sticky');
    before.classList.remove('before-sticky');
  }

  window.onscroll = function () {
    (window.pageYOffset >= sticky) ?
      addSticky(navbar, header) :
      removeSticky(navbar, header);
  };
}



// WEBPACK FOOTER //
// ./app/blocks/navbar/navbar.js